import numeral from "numeral";
import round from "lodash/round";

export const numprice = (
  value: number,
  exp: number = 2,
  format: string = "0,0.00",
  short: boolean = true
): string | number => {
  try {
    const { decimal } = numeral.localeData()?.delimiters || { decimal: "." };
    let res = numeral(round(value, exp)).format(format);

    if (short) {
      res = res.replace(`${decimal}00`, "");
    }

    return res;
  } catch (e) {
    console.log("ERROR", e);
    console.log(value, exp);
    return 0;
  }
};

export function uuid(): string {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const convertTime = (time: number): string => {
  // Calculate hours, minutes and seconds
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time % 3600) / 60);
  const seconds = time % 60;

  // Add leading zeros if needed
  const formatNumber = (num: number): string => num.toString().padStart(2, "0");

  if (hours === 0) {
    return `${minutes} мин`;
  }

  return `${formatNumber(hours)}:${formatNumber(minutes)}`;
};

export const getTimeFromNow = (time: number): string => {
  const now = new Date().getTime();
  const diff = now - time;

  // Convert milliseconds to seconds
  const totalSeconds = Math.floor(diff / 1000);
  return convertTime(totalSeconds);
};

// Export Cloudinary service
export { cloudinaryService, CloudinaryService } from "./cloudinaryService";
export type {
  CloudinaryTransformOptions,
  CloudinaryConfig,
} from "./cloudinaryService";
